'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_data_Segments$SolutionSection(eyebrow, titleLead, titleHighlight, body, checks) {
  this.iy = null;
  this.iz = null;
  this.gE = null;
  this.iw = null;
  this.ix = null;
  this.iy = eyebrow;
  this.iz = titleLead;
  this.gE = titleHighlight;
  this.iw = body;
  this.ix = checks;
}
export { $c_Lio_intela_sites_digitalinternship_data_Segments$SolutionSection as $c_Lio_intela_sites_digitalinternship_data_Segments$SolutionSection };
$p = $c_Lio_intela_sites_digitalinternship_data_Segments$SolutionSection.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_data_Segments$SolutionSection;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_data_Segments$SolutionSection() {
}
export { $h_Lio_intela_sites_digitalinternship_data_Segments$SolutionSection as $h_Lio_intela_sites_digitalinternship_data_Segments$SolutionSection };
$h_Lio_intela_sites_digitalinternship_data_Segments$SolutionSection.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.s = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().W(this, (-1422843604), true);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_digitalinternship_data_Segments$SolutionSection)) {
    if (((((this.iy === x$0.iy) && (this.iz === x$0.iz)) && (this.gE === x$0.gE)) && (this.iw === x$0.iw))) {
      var x = this.ix;
      var x$2 = x$0.ix;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 5;
});
$p.I = (function() {
  return "SolutionSection";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.iy;
      break;
    }
    case 1: {
      return this.iz;
      break;
    }
    case 2: {
      return this.gE;
      break;
    }
    case 3: {
      return this.iw;
      break;
    }
    case 4: {
      return this.ix;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$SolutionSection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bI)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$SolutionSection as $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$SolutionSection };
var $d_Lio_intela_sites_digitalinternship_data_Segments$SolutionSection = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_data_Segments$SolutionSection, "io.intela.sites.digitalinternship.data.Segments$SolutionSection", ({
  bI: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_digitalinternship_data_Segments$SolutionSection as $d_Lio_intela_sites_digitalinternship_data_Segments$SolutionSection };
//# sourceMappingURL=io.intela.sites.digitalinternship.data.-Segments$-Solution-Section.js.map
